import { Button, ButtonWithIcon, Modal, VerticalContainer } from '@/components';
import { TrashIcon } from '@/components/Icons';
import { R } from '@/features/profile/resources/ProfileResources.resx';

export interface DeleteAccountModalProps {
    closeDeleteAccountModal: () => void;
    deleteAccount: () => void;
    isDeleting: boolean;
    error?: string;
}

export const DeleteAccountModal = ({
    closeDeleteAccountModal,
    deleteAccount,
    isDeleting,
    error,
}: DeleteAccountModalProps) => {
    return (
        <Modal
            title={R.DeleteModalTitle}
            onClose={closeDeleteAccountModal}
            className="max-w-lg"
        >
            <VerticalContainer spacing="md">
                <div>{R.DeleteModalText}</div>

                {error && <div className="text-text-danger">{error}</div>}

                <div className="flex justify-end gap-3">
                    <Button
                        variant="ghost"
                        onClick={closeDeleteAccountModal}
                        disabled={isDeleting}
                    >
                        {R.DeleteModalKeepProfile}
                    </Button>

                    <ButtonWithIcon
                        icon={<TrashIcon />}
                        variant="danger"
                        onClick={deleteAccount}
                        disabled={isDeleting}
                    >
                        {R.DeleteAccountButton}
                    </ButtonWithIcon>
                </div>
            </VerticalContainer>
        </Modal>
    );
};
